if (!customElements.get('favorites-list')) {
  customElements.define(
    'favorites-list',
    class FavoritesList extends HTMLElement {
      constructor() {
        super();
        this.grid = this.querySelector('[data-favorites-grid]');
        this.emptyState = this.querySelector('[data-favorites-empty]');
      }

      connectedCallback() {
        this.render();
        this.onFavoriteChange = this.handleFavoriteChange.bind(this);
        document.addEventListener(window.ProductFavorites.event, this.onFavoriteChange);
      }

      disconnectedCallback() {
        document.removeEventListener(window.ProductFavorites.event, this.onFavoriteChange);
      }

      handleFavoriteChange(event) {
        var handle = event.detail.handle;
        var existingItem = this.grid.querySelector('[data-handle="' + handle + '"]');

        if (event.detail.isFavorite) {
          if (existingItem) return;
          this.emptyState.hidden = true;
          this.grid.hidden = false;
          this.fetchCard(handle);
          return;
        }

        if (existingItem) existingItem.remove();
        if (window.ProductFavorites.get().length === 0) {
          this.emptyState.hidden = false;
          this.grid.hidden = true;
        }
      }

      render() {
        var handles = window.ProductFavorites.get();

        if (handles.length === 0) {
          this.emptyState.hidden = false;
          this.grid.hidden = true;
          return;
        }

        this.emptyState.hidden = true;
        this.grid.hidden = false;
        this.grid.innerHTML = '';

        var self = this;
        handles.forEach(function (handle) {
          self.fetchCard(handle);
        });
      }

      fetchCard(handle) {
        var self = this;

        fetch('/products/' + handle)
          .then(function (response) {
            if (!response.ok) throw new Error('Not found');
            return response.text();
          })
          .then(function (responseText) {
            var responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            var template = responseHTML.querySelector('[data-favorite-card]');
            var card = template && template.content.querySelector('product-component');
            if (!card) throw new Error('No card markup');

            var listItem = document.createElement('li');
            listItem.className = 'grid__item';
            listItem.setAttribute('data-handle', handle);
            listItem.appendChild(self.buildRemoveButton(handle));
            listItem.appendChild(card.cloneNode(true));
            self.grid.appendChild(listItem);
          })
          .catch(function () {
            window.ProductFavorites.set(handle, false);
          });
      }

      buildRemoveButton(handle) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'favorites__remove';
        button.setAttribute('aria-label', this.getAttribute('data-label-remove'));
        button.innerHTML = this.querySelector('[data-favorites-remove-icon]').innerHTML;

        button.addEventListener('click', function () {
          window.ProductFavorites.set(handle, false);
        });

        return button;
      }
    }
  );
}
